<template>
    <d2-container class="page">
        <el-row :gutter="20">
            <el-col :span="4">
                <el-card shadow="never" class="d2-card d2-mb">
                    <router-link to="/link" type="div" class="group" style="color: #000">
                        <span>申请：</span>
                        <d2-count-up v-if="form.apply===0" :end="form.apply"/>
                        <d2-count-up v-else :end="form.apply" :callback="() => {className = 'end'}" :class="className"/>
                    </router-link>
                </el-card>
            </el-col>
            <el-col :span="4">
                <el-card shadow="never" class="d2-card d2-mb">
                    <router-link to="/blog" type="div" class="group" style="color: #000">
                        <span>文章：</span>
                        <d2-count-up :end="form.blog"/>
                    </router-link>
                </el-card>
            </el-col>
            <el-col :span="4">
                <el-card shadow="never" class="d2-card d2-mb">
                    <router-link to="/photo" type="div" class="group" style="color: #000">
                        <span>摄影：</span>
                        <d2-count-up :end="form.photo"/>
                    </router-link>
                </el-card>
            </el-col>
            <el-col :span="4">
                <el-card shadow="never" class="d2-card d2-mb">
                    <router-link to="/share" type="div" class="group" style="color: #000">
                        <span>分享：</span>
                        <d2-count-up :end="form.share"/>
                    </router-link>
                </el-card>
            </el-col>
            <el-col :span="4">
                <el-card shadow="never" class="d2-card d2-mb">
                    <router-link to="/link" type="div" class="group" style="color: #000">
                        <span>友链：</span>
                        <d2-count-up :end="form.link"/>
                    </router-link>
                </el-card>
            </el-col>
            <el-col :span="4">
                <el-card shadow="never" class="d2-card d2-mb">
                    <router-link to="/gbook" type="div" class="group" style="color: #000">
                        <span>留言：</span>
                        <d2-count-up :end="form.gbook"/>
                    </router-link>
                </el-card>
            </el-col>
        </el-row>
        <d2-page-cover title="" sub-title="CMS内容管理系统" style="margin-top: 5em">
            <img src="/img/logo.png" alt="">
            <template slot="footer">
                <a href="http://cms.heanny.cn">http://cms.heanny.cn</a>
            </template>
        </d2-page-cover>
    </d2-container>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        data() {
            return {
                className: '',
                form: {apply: 0, blog: 0, photo: 0, share: 0, gbook: 0, link: 0}
            }
        },
        computed: {
            ...mapState('d2admin/releases', [
                'version'
            ])
        }, methods: {

            getData() {
                const _this = this
                this.loading = true
                this.$request({ url: 'getIndex.do'}).then(res => {
                    _this.form = res
                    _this.loading = false
                })
                    .catch((error) => {
                        this.msg = error
                        _this.loading = false
                    })
            }
        }, created: function () {

            this.getData()
        }

    }
</script>

<style lang="scss" scoped>
    @import '~@/assets/style/public.scss';

    .page {
        .page__logo {
            width: 120px;
        }

        .page__btn-group {
            color: $color-text-placehoder;
            font-size: 12px;
            margin-top: -10px;
            margin-bottom: 20px;

            span {
                color: $color-text-sub;

                &:hover {
                    color: $color-text-main;
                }
            }
        }
    }

    .page {
        .group {
            display: flex;
            justify-content: center;
            align-items: center;

            span {
                font-size: 20px;

                &.end {
                    /*padding: 0px 20px;*/
                    /*border-radius: 4px;*/
                    /*background-color: red;*/
                    color: red;
                }
            }
        }
    }
</style>
